// Změny pohledů s okamžitou odezvou: cache se upraví hned, při chybě se vrátí a ukáže toast.
import type { ViewDTO } from '@sam/shared';
import { api } from './api';
import { keys, queryClient } from './queries';

async function optimistic(change: (old: ViewDTO[]) => ViewDTO[], request: () => Promise<unknown>) {
  const before = queryClient.getQueryData<ViewDTO[]>(keys.views);
  if (before) queryClient.setQueryData<ViewDTO[]>(keys.views, change(before));
  try {
    await request();
  } catch (e) {
    if (before) queryClient.setQueryData(keys.views, before);
    throw e;
  }
}

export function updateView(id: string, patch: Partial<Pick<ViewDTO, 'title' | 'cols' | 'onHome'>>) {
  return optimistic(
    (old) => old.map((v) => (v.id === id ? { ...v, ...patch } : v)),
    () => api('PATCH', `/views/${id}`, patch),
  );
}

export function reorderViews(ids: string[]) {
  return optimistic(
    (old) => ids.map((id) => old.find((v) => v.id === id)).filter((v): v is ViewDTO => !!v).concat(old.filter((v) => !ids.includes(v.id))),
    () => api('PUT', '/views/order', { ids }),
  );
}
